import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const ServicesSection = styled.section`
  padding: 80px 0;
  background-color: white;
`;

const SectionTitle = styled.div`
  text-align: center;
  margin-bottom: 50px;
  
  h2 {
    font-size: 2.5rem;
    color: var(--primary-color);
    position: relative;
    display: inline-block;
    padding-bottom: 15px;
    
    &::after {
      content: '';
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: 80px;
      height: 4px;
      background-color: var(--accent-color);
    }
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
`;

const ServiceCard = styled(Link)`
  background-color: var(--light-color);
  padding: 30px;
  border-radius: 10px;
  box-shadow: var(--shadow);
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
  text-decoration: none;
  color: var(--text-color);
  display: block;
  
  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  }
  
  h3 {
    color: var(--primary-color);
    margin-bottom: 15px;
    font-size: 1.5rem;
    position: relative;
    padding-bottom: 10px;
    
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 50px;
      height: 3px;
      background-color: var(--accent-color);
    }
  }
  
  p {
    margin-bottom: 15px;
  }
`;

const ServiceCardFooter = styled.div`
  margin-top: 20px;
  text-align: right;
  color: var(--primary-color);
  font-weight: 500;
`;

function Services() {
  return (
    <ServicesSection id="unsere-dienstleistungen" className="services">
      <div className="container">
        <SectionTitle className="section-title">
          <h2>Unsere Dienstleistungen in Berlin</h2>
        </SectionTitle>
        <ServicesGrid className="services-grid">

          
          <ServiceCard to="/sicherheit" className="service-card">
            <h3>Sicherheitsdienste Berlin</h3>
            <p>
              Als zertifizierter Sicherheitsdienstleister nach §34a Gewerbeordnung 
              bieten wir professionelle Sicherheitskonzepte für Veranstaltungen, 
              Objekte und Kontrolldienste in Berlin und Umgebung.
            </p>
            <ServiceCardFooter className="service-card-footer">Mehr erfahren →</ServiceCardFooter>
          </ServiceCard>
          <ServiceCard to="/taxi" className="service-card">
            <h3>Taxi & Mietwagenservice Berlin</h3>
            <p>
              Wir bringen Sie sicher ans Ziel: vom Taxi über Mietwagen mit Chauffeur 
              bis hin zum Flughafentransfer. Pünktlich, zuverlässig und mit höchstem 
              Komfort -- 365 Tage im Jahr in ganz Berlin und Brandenburg.
            </p>
            <ServiceCardFooter className="service-card-footer">Mehr erfahren →</ServiceCardFooter>
          </ServiceCard>
          
          <ServiceCard to="/reinigung" className="service-card">
            <h3>Reinigungsdienste Berlin</h3>
            <p>
              Unsere Reinigungsteams kümmern sich um die Pflege von privaten und 
              gewerblichen Immobilien in Berlin -- von der regelmäßigen Unterhaltsreinigung 
              bis zu umfassenden Hausmeisterdiensten.
            </p>
            <ServiceCardFooter className="service-card-footer">Mehr erfahren →</ServiceCardFooter>
          </ServiceCard>
        </ServicesGrid>
      </div>
    </ServicesSection>
  );
}

export default Services;